<template>

    <div class="story-group">

        <!-- Group header -->
        <h6 class="font-sm font-weight-bolder" v-if="group.header !== false">{{ headerSanitized }}</h6>

        <!-- Story image & headline -->
        <div v-if="group.story_id" class="story-container media position-relative rounded" @click="$router.push({ name: 'story', query: { id: group.story_id, title: group.story_title, author: group.story_author.name }})">
            <img class="img-centered fill bg-gray-md rounded" :src="'/image/' + storyImage" @error="$root.imageAlt" alt=""/>
            <img class="play-icon" src="/images/icons/icon-play.svg" v-if="group.is_vid" alt=""/>
            <div class="story-text scrim-black position-absolute fixed-bottom" style>
                <div class="position-absolute fixed-bottom text-white">
                    <div class="d-flex flex-row m-4">
                        <div class="pr-4">
                            <h6 class="font-xs text-shadow mb-1">TOP STORY</h6>
                            <h3 class="font-lg font-weight-bold">{{ group.story_title }}</h3>
                            <h6 class="font-xs">{{ group.story_description }}</h6>
                        </div>
                        <div class="align-self-end ml-auto">
                            <button class="btn btn-outline-inverted btn-block" role="button">{{ group.is_vid? 'Watch' : 'Read' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Product cards -->
        <product-card-flex class="mt-3" :product="product" v-for="(product, key) in productsFiltered" :key="key"></product-card-flex>

        <!-- Load more button -->
        <loadmore-button :showLoadMore="group.showLoadMore" v-if="group.hasLoadMore" @loadmore="$emit('loadmore', $event)">{{ group.loadMoreText? group.loadMoreText : "Load more Deals" }}</loadmore-button>

    </div>

</template>

<script>
    const LoadMore = Vue.component('loadmore-button', require('../components/loadmore/LoadMore.vue').default);

    export default {
        components: { LoadMore },

        props: ["group", "gid"],

        computed: {
            headerSanitized() {
                return _.capitalize(this.group.header)
            },
            productsFiltered() {
                return this.group.cards.filter(function (el) {
                    return typeof(el.id) !== 'undefined'
                });
            },
            storyImage: function() {
                return this.group.imageId? this.group.imageId : 0
            },
        }
    }
</script>